// Template Generated by DataExtraction.py at 1717541024

import CESGEnglishD1 from "../../Forms/CESG/CESG_EnglishD1.png";
import CESGEnglishD1Labels from "../../Labels/CESG/CESG_EnglishD1.json";
import CESGFrenchD1 from "../../Forms/CESG/CESG_FrenchD1.png";
import CESGFrenchD1Labels from "../../Labels/CESG/CESG_FrenchD1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, isFemale, isMale, drawText as drawTextAtPos, isAnotherGender
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import { t } from "i18next";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchD1Labels : CESGEnglishD1Labels;
    const formImage = isFrench ? CESGFrenchD1 : CESGEnglishD1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const beneficiary = data.beneficiary;
    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;

    const subscriber2Include = data.common.subscriber2Include;

    const format = "yyyy/MM/DD";

    // drawTextAtPos(doc, 12, t("Children's Education Funds Inc."), 51 / 3.38, 260 / 3.38, 454 / 3.38);
    drawText(t("Children's Education Funds Inc."), "respProvider")
    drawText(t("1"), "numBenes")


    // Drawing the form
    drawText(moment(beneficiary.birthdate).format(format), "beneficiaryBirthdateYyyyMmDd");
    fillCheckbox(isFemale(beneficiary.gender), "beneficiaryFemale");
    fillCheckbox(isAnotherGender(beneficiary.gender), "beneficiaryAnother");
    drawText(beneficiary.firstName, "beneficiaryFirstName");
    drawText(beneficiary.lastName, "beneficiaryLastName");
    fillCheckbox(isMale(beneficiary.gender), "beneficiaryMale");
    drawText(beneficiary.sin, "beneficiarySin");
    drawText(subscriber.firstName, "subscriber1FirstName");
    drawText(subscriber.lastName, "subscriber1LastName");
    if (subscriber2Include) {
        drawText(jointSubscriber.firstName, "subscriber2FirstName");
        drawText(jointSubscriber.lastName, "subscriber2LastName");
    }
    drawText(subscriber.streetNumber + " " + subscriber.address, "subscriberAddress");
    drawText(subscriber.suite, "subscriberAppt");
    drawText(subscriber.city, "subscriberCity");
    drawText(subscriber.country, "subscriberCountry");
    drawText(subscriber.postalCode, "subscriberPostalCode");
    drawText(subscriber.province, "subscriberProvince");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchD1Labels : CESGEnglishD1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
